import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, Grid, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import Loading from "../../components/Loading/index";
import FulltextSearchForm from "../../components/Forms/FulltextSearchForm";

class BadgeList extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            badges: [],
            removeBadge: null,
            fulltext: null,
            loading: true
        };

        // handles for fulltext search
        this.handleChangeFulltext = this.handleChangeFulltext.bind(this);
        this.handleSubmitFulltext = this.handleSubmitFulltext.bind(this);

        // modal
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        this.getBadges()
    };

    getBadges(fulltext) {
        axios.get(this.props.api.badges, {
            params: {
                q: fulltext
            }
        }).then((result) => {
            this.setState({
                badges: result.data,
                loading: false
            });
        }).catch(function (error) {
            console.error('Error axios:', error);
        });
    }

    handleChangeFulltext(event) {
        this.setState({
            fulltext: event.target.value
        });
    }

    handleSubmitFulltext(event) {
        event.preventDefault();
        this.getBadges(this.state.fulltext);
    }

    closeModal() {
        this.setState({
            showModal: false,
            removeBadge: null
        })
    }

    showModal(badge) {
        this.setState({
            showModal: true,
            removeBadge: badge
        })
    }

    render() {
        let {size} = this.props;
        let {badges, removeBadge} = this.state;
        let content;

        const tooltipEdit = (
            <Tooltip id="tooltip-edit">Upravit</Tooltip>
        );
        const tooltipRemove = (
            <Tooltip id="tooltip-remove">Odstranit</Tooltip>
        );


        if (this.state.loading) {
            content = <Loading message="Načítám odznaky..."/>
        } else {
            content = badges.length > 0 ?
            <Grid>
                {[...badges].map((badge, index) => {
                        let url = `${__APIURL__}/${badge.filePath}`;
                        return (
                            <div className="badge-block" key={index}>
                                <img alt={"badge " + index}
                                     src={url}
                                     className="myBadge"
                                     height={size.height}
                                     width={size.width}
                                />
                                <div className="menu-bar">
                                    <OverlayTrigger placement="top" overlay={tooltipEdit}>
                                        <Link to={`/badges/edit/${badge.id}`}>
                                            <FontAwesome name="pencil-square-o" />
                                        </Link>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="top" overlay={tooltipRemove}>
                                        <FontAwesome name="trash"
                                                     onClick={() => this.showModal(badge)}/>
                                    </OverlayTrigger>
                                </div>
                                <div className="name" style={{width: size.width}}>
                                    {badge.name}
                                </div>
                            </div>
                        )
                    }
                )}
            </Grid>
            : <p>Nenalezeny žádné odznaky.</p>
        }

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Seznam odznaků</h2>
                    <Button className="btn-success btn-add" onClick={() => this.props.history.push('/badges/add')}>
                        <FontAwesome name="plus"/>
                    </Button>
                    <div className="filter">
                        <FulltextSearchForm
                            label="Vyhledat podle názvu:"
                            placeholder="Zadejte název"
                            handleChange={this.handleChangeFulltext}
                            handleSubmit={this.handleSubmitFulltext}
                        />
                    </div>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {content}
                </div>
                {
                    removeBadge &&
                    <Modal show={this.state.showModal} onHide={this.closeModal} backdrop='static'>
                        <Modal.Header closeButton className="text-danger bg-danger">
                            <Modal.Title>Odstranění odznaku</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Opravdu chcete odstranit odznak: {removeBadge.name}?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeModal}>Zrušit</Button>
                            <Button className='btn btn-danger' onClick={() => this.props.handleRemoveBadge(removeBadge)}>Odstranit</Button>
                        </Modal.Footer>
                    </Modal>
                }
            </div>
        );
    }
}

export default withRouter(BadgeList);



/** WEBPACK FOOTER **
 ** ./src/containers/Badges/BadgeList.js
 **/